export default "__VITE_ASSET__DgWHgR9Y__"